import type { ActorProfile, FeedPost, ModerationLabel } from './types';

const SENSITIVE_LABELS = new Set([
  'porn',
  'sexual',
  'nudity',
  'graphic-media',
  '!warn',
]);

function mustHide(labels: ModerationLabel[] = []): boolean {
  return activeLabelValues(labels).includes('!hide');
}

export function activeLabelValues(labels: ModerationLabel[] = []): string[] {
  const values = new Map<string, boolean>();
  labels.forEach(label => values.set(label.val, !label.neg));
  return [...values]
    .filter(([, active]) => active)
    .map(([value]) => value);
}

export function hasSensitiveLabels(labels: ModerationLabel[] = []): boolean {
  return activeLabelValues(labels).some(value => SENSITIVE_LABELS.has(value));
}

export function hidesLoggedOut(labels: ModerationLabel[] = []): boolean {
  return activeLabelValues(labels).includes('!no-unauthenticated');
}

export function shouldHideActor(
  actor: ActorProfile,
  showSensitiveContent: boolean,
  authenticated: boolean,
): boolean {
  return mustHide(actor.labels)
    || (!showSensitiveContent && hasSensitiveLabels(actor.labels))
    || (!authenticated && hidesLoggedOut(actor.labels));
}

export function visibleActors(
  actors: ActorProfile[],
  blockedHandles: Set<string>,
  showSensitiveContent: boolean,
  authenticated: boolean,
): ActorProfile[] {
  return actors
    .filter(actor => !blockedHandles.has(actor.handle.toLowerCase()))
    .filter(actor => !shouldHideActor(actor, showSensitiveContent, authenticated));
}

export function shouldHidePost(
  post: FeedPost,
  showSensitiveContent: boolean,
  authenticated: boolean,
): boolean {
  return shouldHideActor(post.author, showSensitiveContent, authenticated)
    || mustHide(post.labels)
    || (!showSensitiveContent && hasSensitiveLabels(post.labels))
    || (!authenticated && hidesLoggedOut(post.labels));
}
